import { observer } from 'mobx-react-lite'
import type { PersonalInfoEditorViewModel } from '@/features/tax-profile/individual-profiles/PersonalInfoEditorViewModel'
import { TextFieldContainer } from '@/components/inputs/TextFieldContainer'
import { FormFieldGroup } from '@/components/Form'
import { StyledLink } from '@/components/Link'
import { useState } from 'react'
import { DateFieldContainer } from '@/components/inputs/DateFieldContainer'
import { masks } from '@/utils/input-mask-util'
import { PrivacyInfoDialog } from '@/components/PrivacyInfoDialog'

export interface PersonalInfoEditorProps {
  vm: PersonalInfoEditorViewModel
  privacyDialogTestId?: string
  privacyDialogCloseButtonTestId?: string
  testId?: string
}

/**
 * Form fields for personal information.
 */
export const PersonalInfoEditor = observer(function PersonalInfoEditor({
  vm,
  privacyDialogTestId,
  privacyDialogCloseButtonTestId,
  testId,
}: PersonalInfoEditorProps) {
  const [isPrivacyDialogOpen, setIsPrivacyDialogOpen] = useState(false)
  return (
    <>
      <FormFieldGroup stackWhenCompact>
        <TextFieldContainer
          model={vm}
          field="firstName"
          placeholder="e.g. John"
          label="First name"
          testId={testId ? `${testId}-first-name-input` : undefined}
        />
        <TextFieldContainer
          model={vm}
          field="middleInitial"
          label="Middle initial"
          placeholder="e.g. R"
          testId={testId ? `${testId}-middle-initial-input` : undefined}
        />
      </FormFieldGroup>
      <TextFieldContainer
        model={vm}
        field="lastName"
        placeholder="e.g. Doe"
        label="Last name"
        testId={testId ? `${testId}-last-name-input` : undefined}
      />
      <DateFieldContainer
        model={vm}
        field="dateOfBirth"
        placeholder="MM/DD/YYYY e.g. 04/28/1998"
        label="Date of birth"
        data-private
        testId={testId ? `${testId}-date-of-birth-input` : undefined}
      />
      <TextFieldContainer
        model={vm}
        field="personalTaxpayerIdentificationNumber"
        placeholder="e.g. 123-45-6789"
        label="SSN or ITIN"
        mask={masks.ssnOrItin}
        data-private
        testId={testId ? `${testId}-ssn-or-itin-input` : undefined}
        hint={
          <>
            <StyledLink
              variant="inherit"
              onPress={() => setIsPrivacyDialogOpen(true)}
              testId={testId ? `${testId}-privacy-link` : undefined}
            >
              We take your privacy seriously
            </StyledLink>
          </>
        }
      />
      <PrivacyInfoDialog
        isOpen={isPrivacyDialogOpen}
        onClose={() => setIsPrivacyDialogOpen(false)}
        testId={privacyDialogTestId}
        closeButtonTestId={privacyDialogCloseButtonTestId}
      />
    </>
  )
})
